import { Box, useTheme } from "@mui/material";

type Props = {
  children: React.ReactNode;
};

export default function SectionWrapper({ children }: Props) {
  const theme = useTheme();
  return (
    <Box
      component="section"
      sx={{
        border: `2px solid ${theme.palette.divider}`,
        borderRadius: "12px",
        padding: "24px",
        marginTop: "32px",
      }}
    >
      {children}
    </Box>
  );
}
